import style from "./style.scss";
import { mergeClasses } from "../../../../components/helpers";

const CompatibilityIcon = ({
  status,
  mini = false,
  class: className = null,
  ...props
}) => {
  let cssClass;
  switch (status) {
    case "direct":
      cssClass = style.compatibility_direct;
      break;
    case "adapter":
      cssClass = style.compatibility_adapter;
      break;
    case "unofficial":
      cssClass = style.compatibility_unofficial;
      break;
    case "unofficial-bright":
      cssClass = style.compatibility_unofficial_bright;
      break;
    case "none":
    default:
      cssClass = style.compatibility_none;
      break;
  }

  return mini ? (
    <span
      aria-hidden="true"
      class={mergeClasses([style.compatibility, cssClass, className])}
      {...props}
    />
  ) : (
    <span
      aria-hidden="true"
      class={mergeClasses([style.compatibilityWrapper, cssClass, className])}
      {...props}
    >
      <span class={mergeClasses([style.compatibility, cssClass])} />
    </span>
  );
};

export default CompatibilityIcon;
